/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { useCallback } from 'react';
import { scroller } from 'react-scroll';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as FileServer from 'file-saver';
import filesize from 'filesize';

import { ReactComponent as AlertIcon } from '../../../assets/icons/ubr_alert.svg';
import { ReactComponent as DownloadIcon } from '../../../assets/icons/ubr_download.svg';
import { ReactComponent as UpdateIcon } from '../../../assets/icons/ubr_update.svg';
import {
  Button,
  Divider,
  Layout,
  Modal,
  Shimmer,
  Pagination,
} from '../../../components';
import { Accordion, Upload } from '../../../components';
import FileList from '../../../components/Upload/FileList';
import { useToast } from '../../../hooks/toast';
import { useAuth } from '../../../hooks/useAuth';
import api from '../../../services/api';
import { EndpointsAPI } from '../../../services/Endpoints';
import { DateFormAndTime } from '../../../utils/date';
import { hash } from '../../../utils/hashGenerator';
import {
  Badge,
  LoadingData,
  TableContainer,
  HeaderTable,
  ImportFileContainer,
  Label,
  FileWrapper,
  FooterContainer,
  Container,
  List,
  BadgeError,
} from './styles';

interface FileProps {
  file: File | any | undefined;
  name: string;
  readableSize: string;
}

interface DataProps {
  pageable: [
    {
      pageNumber: number;
      pageSize: number;
    },
  ];
  totalElements: number;
  totalPages: number;
}

export const Motor: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<DataProps | any>([]);
  const [uploadedCnab, setuploadedCnab] = useState<FileProps[] | any>([]);
  const formRefCnab = useRef<FormHandles | null>(null);
  const [showErrorFile, setShowErrorFile] = useState<boolean>(false);
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [pageSizeData, setPageSizeData] = useState<number>(5);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const { addToast } = useToast();
  const { user } = useAuth();

  const fetchData = useCallback(
    async (apiPage: number, apiPageSize: number) => {
      setIsLoading(true);

      const { data } = await api.get(
        `${EndpointsAPI.motorConvenios}/identificadorEmpresa/${user.identificadorEmpresa}?page=${apiPage}&size=${apiPageSize}`,
      );

      setData(data);
      setIsLoading(false);
    },
    [],
  );

  const scrollTo = () => {
    scroller.scrollTo('tableData', {
      duration: 1000,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: -120,
    });
  };

  useEffect(() => {
    fetchData(0, pageSizeData);
  }, []);

  const loadingTable = () => {
    return (
      <tr>
        <td>
          <div
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </div>
        </td>
        <td>
          <div
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </div>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
      </tr>
    );
  };

  const [filter, setFilter] = useState<Object>({
    identificadorEmpresa: null,
    dataInicio: null,
    dataFim: null,
    periodo: null,
  });

  const processDownload = async (identificadorArquivoRetorno:string) => {
    const response = await api.get('/retorno/carregar/?nomeArquivo='.concat(identificadorArquivoRetorno));
    const url = URL.createObjectURL(
      new Blob([response.data], {
        type: 'text/TXT;charset=utf-8',
      }),
    );


    FileServer.saveAs(url, identificadorArquivoRetorno + '.TXT');
  };

  // Render Posts

  const renderPost = () => {
    let { pageSize, totalPages } = data;

    return (
      <>
        <TableContainer>
          <HeaderTable>
            <Button
              variant={'solid-icon'}
              onClick={() => fetchData(0, pageSizeData)}
              tooltipText={'Atualizar tabela'}
            >
              <UpdateIcon width={28} className={isLoading ? 'rotate' : ''} />
            </Button>
          </HeaderTable>
          <div>
            <table id="tableData">
              <thead>
                <tr>
                  <th style={{ width: '100px' }}>Data</th>
                  <th style={{ width: '100px' }}>Validação</th>
                  <th style={{ width: '150px' }}>Status</th>
                  <th style={{ width: '100px' }}>Download</th>
                </tr>
              </thead>
              {isLoading ? (
                <tbody>
                  {loadingTable()}
                  {loadingTable()}
                  {loadingTable()}
                </tbody>
              ) : !data.content ? (
                <LoadingData> Sem dados para exibir... </LoadingData>
              ) : (
                <tbody>
                  {data.content.map((todo: any, index: number) => {
                    return (
                      <>
                        <tr key={index}>
                          <td data-column="Data">
                            {todo.leitorCnab !== null
                              ? DateFormAndTime(todo.leitorCnab.dataCriacao)
                              : 'N/A'}
                          </td>

                          <td data-column="Validação">
                            <div>
                              <Badge
                                type={
                                  todo.motorCnab !== null
                                    ? todo.motorCnab.status
                                    : todo.leitorCnab !== null
                                    ? todo.leitorCnab.status
                                    : 'DEFAULT'
                                }
                                onClick={
                                  todo.leitorCnab !== null
                                    ? todo.leitorCnab.status === 'ERRO'
                                      ? () =>
                                          showModalError(
                                            todo.leitorCnab.idArquivoMotor,
                                          )
                                      : (() => {}) ||
                                        todo.motorCnab.status === 'ERRO'
                                      ? () =>
                                          showModalError(
                                            todo.motorCnab.idArquivoMotor,
                                          )
                                      : () => {}
                                    : () => {}
                                }
                              >
                                CNAB
                              </Badge>
                            </div>
                          </td>

                          <td data-column="Status">
                            <BadgeError type={todo.status}>
                              {todo.status ? todo.status : 'AGUARDANDO'}
                            </BadgeError>
                            <p>{todo.mensagemProcesso}</p>
                          </td>

                          <td data-column="Download">
                            {todo.status === 'SUCESSO' ? (
                              <Button
                                onClick={() => { processDownload(todo.identificadorArquivoRetorno)}}
                                variant={'solid-icon'}
                                tooltipText={'Baixar Arquivo de Retorno'}
                                style={{ width: '24px' }}
                              >
                                <DownloadIcon />
                              </Button>
                            ) : (
                              'Sem arquivo de retorno'
                            )}
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              )}
            </table>
          </div>
        </TableContainer>

        <div>
          <Pagination
            pageCount={totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={pageSize}
            forcePage={currentPage - 1}
            onPageChange={(pageNumber: any) => {
              setCurrentPage(pageNumber.selected + 1);
              fetchData(pageNumber.selected, pageSizeData);
            }}
            onPageSize={(pageSize: any) => {
              setCurrentPage(1);
              setPageSizeData(pageSize.value);
              fetchData(0, pageSize.value);
            }}
          />
        </div>
      </>
    );
  };

  // File Upload Cnab

  const handleSubmitCnab = useCallback(async () => {
    setIsLoading(true);
    const { file } = uploadedCnab[0];

    const dataFile = new FormData();
    dataFile.append('file', file, file.name);
    dataFile.append('cooperativa', user.cooperativa);
    dataFile.append('identificadorEmpresa', user.identificadorEmpresa);

    const response = await api
      .post(`${EndpointsAPI.motorConveniosCnab}`, dataFile, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        validateStatus: () => {
          return true;
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        return error;
      });

    try {
      if (response.status === 400 || response.status === 401) {
        addToast({
          type: 'error',
          title: `Erro ao enviar o CNAB`,
          description: `${response.data.details[0]}`,
          time: 6000,
        });
        fetchData(0, pageSizeData);
        removeFileCnab();
      } else {
        addToast({
          type: 'success',
          title: `Sucesso ao enviar o CNAB`,
          description: `Arquivo CNAB enviado para extração dos dados.`,
          time: 6000,
        });

        removeFileCnab();
        scrollTo();
        setTimeout(() => {
          fetchData(0, pageSizeData);
          setIsLoading(false);
        }, 1500);
      }
    } catch (err) {
      console.error(err);
    }
  }, [uploadedCnab]);

  function submitFileCnab(files: File[]): void {
    const fileUpload = files.map(file => ({
      file,
      name: file.name,
      readableSize: filesize(file.size),
      type: file.type,
    }));
    setuploadedCnab(fileUpload);
    setShowErrorFile(true);
  }

  const removeFileCnab = () => {
    setuploadedCnab('');
  };

  const [idError, setIdError] = useState<string>();
  const [dataError, setDataError] = useState<[]>([]);

  const showModalError = (id: string) => {
    setShowErrorModal(true);
    setIdError(id);
    fetchError(id);
  };

  const fetchError = useCallback(async (id: string) => {
    const { data } = await api.get(
      EndpointsAPI.motorConvenios + `/${id}/criticas`,
    );
    setDataError(data);
  }, []);

  // =========================================================================================
  
  return (
    <>
      <Modal
        show={showErrorModal}
        titulo={'Erro no arquivo CNAB enviado'}
        mensagem={`Você deve verificar os erros, corrigi-los e tentar novamente.`}
        onCancel={() => {
          setShowErrorModal(false);
          setDataError([]);
        }}
        onConfirm={() => {}}
      >
        {dataError.length ? (
          dataError.map((data: any, index: number) => {
            return (
              <>
                <List>
                  <div className="list-content-secondary">
                    <span>
                      <b> ERRO ENCONTRADO: </b>
                    </span>
                    {data.mensagem}
                  </div>

                  <li>
                    <b className="list-content-principal">DETALHES DE ERRO: </b>
                    <>
                      Linha: {data.posicaoLinha}, Posição Inicial:{' '}
                      {data.posicaoInicial}, Posição Final: {data.posicaoFinal}
                    </>
                  </li>

                  {data.valorEsperado === null ||
                  data.valorEsperado === undefined ||
                  data.valorEsperado === '' ||
                  data.valorEsperado === 'SEM VALOR ESPERADO' ? null : (
                    <li>
                      <b className="list-content-principal">VALOR ESPERADO: </b>
                      {data.valorEsperado}
                    </li>
                  )}

                  <li>
                    <b className="list-content-principal">VALOR INFORMADO: </b>
                    {data.valor}
                  </li>
                  <li>
                    <b className="list-content-principal">TIPO DE LAYOUT: </b>
                    {data.tipoValidacao}
                  </li>
                  <Accordion
                    id={hash(index)}
                    key={index}
                    title="Mais Informações"
                    description={
                      <>
                        <li>
                          <b>Campo: </b>
                          {data.chave}
                        </li>
                        <li>
                          <b>Tipo de segmento: </b>
                          {data.tipoValidacaoModelo}
                        </li>

                        <li>
                          <b>Tipo de validação: </b>
                          {data.validacaoCritica}
                        </li>
                      </>
                    }
                  />
                </List>
              </>
            );
          })
        ) : (
          <>
            <div style={{ marginTop: '2rem' }}>
              <Shimmer height={'25px'} />
              <div style={{ display: 'flex', marginTop: '0.5rem' }}>
                <Shimmer width={'60%'} height={'25px'} />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Shimmer height={'25px'} />
              </div>
              <div style={{ display: 'flex', marginTop: '0.5rem' }}>
                <Shimmer width={'60%'} height={'25px'} />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Shimmer height={'25px'} />
              </div>
              <div style={{ display: 'flex', marginTop: '0.5rem' }}>
                <Shimmer width={'60%'} height={'25px'} />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Shimmer height={'25px'} />
              </div>
              <div style={{ marginTop: '1rem' }}>
                <Shimmer height={'25px'} />
              </div>
            </div>
          </>
        )}
      </Modal>
      <Layout title="Motor de Convênios" titlePage={'Motor de Convênios'}>
        <Container>
          <Form
            className="form-container"
            ref={formRefCnab}
            onSubmit={handleSubmitCnab}
          >
            <ImportFileContainer>
              <Label>Arquivos</Label>
              <FileWrapper>
                {!!uploadedCnab.length && (
                  <FileList files={uploadedCnab} handleErase={removeFileCnab} />
                )}
              </FileWrapper>
              <Upload
                onUpload={submitFileCnab}
                accept={'text/*, .REM, .rem, .ret, .RET'}
              />
              <FooterContainer>
                <p>
                  <AlertIcon />
                  Limite máximo de 5mb
                </p>
                <div>
                  <Button
                    variant="solid"
                    style={{ marginTop: '1rem' }}
                    type="submit"
                    disabled={!uploadedCnab.length}
                    loading={uploadedCnab.length && isLoading}
                    loadingMessage={'Enviando Arquivo...'}
                  >
                    Adicionar
                  </Button>
                </div>
              </FooterContainer>
            </ImportFileContainer>
          </Form>
        </Container>
        <Divider marginAround={'2rem'} />
        <div>{data && renderPost()}</div>
      </Layout>
    </>
  );
};
